import BaseService from "../base.service";
//import http from "../../http-common";

class AssignementService extends BaseService {
  constructor() {
    super("assignements");
  }
}

export const Assignement = new AssignementService();